// Banda a todo el ancho «Todos los números filtrados a:» con el selector de periodo del mock.
import { AlertTriangle } from 'lucide-react';
import { formatDayMx } from '@/lib/dateHelpers';
import { REPORT_PERIOD_OPTIONS, reportPeriodRange, type ReportPeriod } from './reportPeriod';

export const TRUNCATED_NOTICE =
    'Números parciales: el periodo excede el tope de ventas que se pueden sumar. Elige un periodo más corto para ver el total completo.';

export function PeriodBand({
    period,
    onPeriodChange,
    truncated = false,
    goalNote = true,
    note,
    now,
}: {
    period: ReportPeriod;
    onPeriodChange: (period: ReportPeriod) => void;
    /** Alguna KPI del periodo llegó recortada por el tope del backend. */
    truncated?: boolean;
    /** La pantalla escala la meta al periodo; sin meta, la nota se omite. */
    goalNote?: boolean;
    /** Nota propia de la pantalla tras el rango; sustituye la de la meta. */
    note?: string;
    now?: Date;
}) {
    const { fromDay, toDay } = reportPeriodRange(period, now);
    return (
        <div className="flex flex-none flex-wrap items-center gap-2.5 border-b border-warning-soft-border bg-warning-soft px-3.5 py-2 text-[11px]">
            <label
                htmlFor="report-period"
                className="text-[9.5px] font-bold uppercase tracking-[0.05em] text-warning"
            >
                Todos los números filtrados a:
            </label>
            <select
                id="report-period"
                value={period}
                onChange={(e) => {
                    onPeriodChange(e.target.value as ReportPeriod);
                }}
                className="cursor-pointer rounded border border-warning bg-warning px-2.5 py-[3px] text-[12px] font-bold text-warning-foreground focus:outline-none focus:ring-2 focus:ring-warning/30"
            >
                {REPORT_PERIOD_OPTIONS.map((option) => (
                    <option
                        key={option.value}
                        value={option.value}
                        className="bg-card text-foreground"
                    >
                        {option.label}
                    </option>
                ))}
            </select>
            <span data-testid="period-hint" className="text-[10.5px] text-warning/80">
                del{' '}
                <strong className="font-bold tabular-nums text-warning">
                    {formatDayMx(fromDay)}
                </strong>{' '}
                al{' '}
                <strong className="font-bold tabular-nums text-warning">
                    {formatDayMx(toDay)}
                </strong>
                {note !== undefined
                    ? ` · ${note}`
                    : period === 'all'
                      ? ' · sin meta comparativa'
                      : goalNote
                        ? ' · meta escalada al periodo'
                        : ''}
            </span>
            {truncated ? (
                <span
                    role="alert"
                    className="inline-flex items-center gap-1 rounded border border-destructive/40 bg-destructive/10 px-2 py-0.5 text-[10.5px] font-semibold text-destructive"
                >
                    <AlertTriangle className="size-3" aria-hidden />
                    {TRUNCATED_NOTICE}
                </span>
            ) : null}
        </div>
    );
}
